var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyAccountTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22109",
    "data-name": "Group 22109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.287,
    height: 19.666,
    viewBox: "0 0 18.287 19.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9347",
    "data-name": "Rectangle 9347",
    width: 18.287,
    height: 19.667,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22106",
    "data-name": "Group 22106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16108",
    "data-name": "Path 16108",
    d: "M62.805,19.667h-.46a1.021,1.021,0,0,1-.842-1.144q0-3.153,0-6.306c0-.23,0-.46-.008-.69.016-1.236,0-2.471.007-3.707a.713.713,0,0,1,.041-.338c.1-.117.233-.088.357-.088q2.243,0,4.485,0c.447,0,.895,0,1.342,0,.321,0,.363.047.368.366a.357.357,0,0,0,.024.2c.122-.085.23-.182.341-.276.424-.359.857-.708,1.282-1.067.176-.149.176-.173,0-.318-.508-.428-1.021-.851-1.53-1.278a.361.361,0,0,0-.107-.068,1.412,1.412,0,0,0-.017.306.222.222,0,0,1-.241.238c-.057,0-.115,0-.172,0q-2.885,0-5.77,0a.5.5,0,0,1-.35-.065.593.593,0,0,1-.054-.353c0-1.327,0-2.654,0-3.98a.948.948,0,0,0-.577-.933A.421.421,0,0,1,60.8.09c-.024-.024-.04-.05-.015-.083A1.3,1.3,0,0,1,60.991,0H71.748a1.333,1.333,0,0,1,1.416,1.415q.005,3.892,0,7.785a.563.563,0,0,1-.043.281c-.1.114-.234.085-.358.086q-2.56,0-5.12,0c-.23,0-.46,0-.69,0-.338,0-.377-.042-.383-.371a.269.269,0,0,0-.025-.178c-.254.2-.493.406-.737.608-.31.256-.618.516-.928.773-.1.079-.11.148-.01.231.557.468,1.117.934,1.694,1.413.016-.122,0-.224.011-.324.015-.192.066-.242.262-.257.032,0,.064,0,.1,0q2.943,0,5.887,0c.106,0,.221-.014.3.084a.541.541,0,0,1,.044.28q0,2.755,0,5.509a.5.5,0,0,1-.054.3.452.452,0,0,1-.345.076q-1.763,0-3.525,0H64.087c-.077,0-.153,0-.23,0-.123,0-.171.058-.171.176q0,.354,0,.709a1.287,1.287,0,0,1-.236.717.842.842,0,0,1-.645.356",
    transform: "translate(-58.189 0)",
    fill: "#fee7b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16109",
    "data-name": "Path 16109",
    d: "M119.057,415.454l.651,0a1.015,1.015,0,0,1,.328,1.985c-.035.012-.078.009-.1.048H108.77a1.114,1.114,0,0,0,.689-.564,1.163,1.163,0,0,0,.118-.5c0-.275,0-.55,0-.825,0-.1.033-.157.143-.148.051,0,.1,0,.153,0h8.918c.089,0,.179,0,.268,0",
    transform: "translate(-104.154 -397.824)",
    fill: "#fecb86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16110",
    "data-name": "Path 16110",
    d: "M1.353,115.925c-.39,0-.78-.012-1.17-.005-.145,0-.185-.042-.183-.184q.011-.834,0-1.669c0-.142.037-.188.183-.185.39.007.78,0,1.17,0a.36.36,0,0,1,.27-.074q.748,0,1.5,0a.355.355,0,0,1,.27.074c.345,0,.69.007,1.035.008H9.565c.294,0,.26.032.262-.271,0-.115,0-.229,0-.359a.553.553,0,0,1,.238.16c.547.451,1.089.91,1.639,1.359.128.1.132.155,0,.263-.576.467-1.141.948-1.711,1.422a.229.229,0,0,1-.164.086c0-.165,0-.329,0-.492,0-.1-.027-.137-.13-.137q-3.155.007-6.311.01a.4.4,0,0,1-.273.064H1.625a.412.412,0,0,1-.273-.064",
    transform: "translate(0 -108.448)",
    fill: "#2a89c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16111",
    "data-name": "Path 16111",
    d: "M161.02,208.882c1.048,0,2.1.01,3.143,0,.2,0,.248.051.243.245-.014.53-.01,1.061,0,1.591,0,.157-.04.206-.2.206-1.06,0-2.121,0-3.182,0-.3,0-.6-.007-.9-.007-1.777,0-3.554,0-5.331,0-.164,0-.235.036-.217.211a4.057,4.057,0,0,1,0,.418.874.874,0,0,1-.343-.242c-.522-.43-1.039-.866-1.559-1.3-.063-.052-.127-.092-.029-.174.632-.524,1.262-1.051,1.931-1.608,0,.2.005.356,0,.511-.005.118.041.166.156.153a.705.705,0,0,1,.077,0h6.04c.057,0,.115,0,.172,0",
    transform: "translate(-146.12 -199.387)",
    fill: "#92c997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16112",
    "data-name": "Path 16112",
    d: "M33.7,5.781H31.664c0-1.416.023-2.832-.009-4.248A1.069,1.069,0,0,1,32.888.38a1.065,1.065,0,0,1,.811,1.2q0,2.1,0,4.2",
    transform: "translate(-30.312 -0.352)",
    fill: "#f7a94c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16113",
    "data-name": "Path 16113",
    d: "M31.777,176.189h2.035q0,1.922,0,3.844c0,.073.028.154-.038.217-.588,0-1.176-.009-1.764,0-.179,0-.236-.035-.235-.227.009-1.278,0-2.557,0-3.835",
    transform: "translate(-30.425 -168.712)",
    fill: "#f7a94c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16114",
    "data-name": "Path 16114",
    d: "M154.68,376.342h-3.165c-.246,0-.249,0-.25-.244,0-.446,0-.446.439-.446,2.04,0,4.079,0,6.118,0,.181,0,.244.042.239.232-.012.462,0,.462-.466.462H154.68",
    transform: "translate(-144.846 -359.707)",
    fill: "#eed9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16115",
    "data-name": "Path 16115",
    d: "M154.668,344c1.061,0,2.122,0,3.183,0,.168,0,.221.044.217.215-.009.441,0,.441-.447.441h-6.1c-.251,0-.251,0-.252-.25,0-.4,0-.4.4-.4h2.991",
    transform: "translate(-144.853 -329.401)",
    fill: "#eed9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16116",
    "data-name": "Path 16116",
    d: "M121.217,40.208c.5,0,1.009,0,1.514,0,.132,0,.176.04.178.175.007.518.012.518-.5.518-.888,0-1.776,0-2.663,0-.167,0-.22-.043-.217-.214.008-.48,0-.48.485-.48h1.207",
    transform: "translate(-114.452 -38.5)",
    fill: "#eed9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16117",
    "data-name": "Path 16117",
    d: "M121.193,72.519c-.5,0-1,0-1.495,0-.134,0-.174-.044-.176-.176-.007-.516-.011-.516.5-.516.888,0,1.776,0,2.663,0,.17,0,.218.048.216.216-.008.478,0,.478-.487.478h-1.226",
    transform: "translate(-114.449 -68.777)",
    fill: "#eed9a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16118",
    "data-name": "Path 16118",
    d: "M264.344,312.18c-.281,0-.562-.006-.842,0-.137,0-.182-.047-.173-.179a2.669,2.669,0,0,0,0-.344c-.007-.119.028-.173.16-.172q.862.008,1.723,0c.118,0,.159.045.154.159a3.769,3.769,0,0,0,0,.383c.007.12-.048.154-.16.152-.287,0-.574,0-.862,0",
    transform: "translate(-252.153 -298.269)",
    fill: "#eed9a5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountTransactions);
export default __webpack_public_path__ + "static/media/my-account-transactions.e0773396f0595eb2ffe58379db05e6a3.svg";
export { ForwardRef as ReactComponent };